// extracted by mini-css-extract-plugin
export default {"labelWrapper":"styles__labelWrapper--uXEY_","formLabel":"styles__formLabel--hy0LG","labelWrapperErrorText":"styles__labelWrapperErrorText--C7p56 styles__formLabel--hy0LG"};